import React from "react";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge
} from "reactstrap";
import DeleteButton from "./AuthorUIComponents/DeleteButton";
import uuid from 'uuid';
export default class Filter extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      selectedFilter: "",
      appliedFilters: []
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }
  handleFilters() {
    let updateFilters = this.state.appliedFilters;
    updateFilters.push({
      id:uuid(),
      type: this.state.selectedFilter,
      value: this.props.filter
    });
    this.setState({ appliedFilters: updateFilters });
  }
  deleteTag(tagId){
    let updatedFilterTags = this.state.appliedFilters.filter(filterTag => (!(filterTag.id === tagId)) );
    this.setState({appliedFilters:updatedFilterTags});
  }
  render() {
    const { onChg, filter } = this.props;
    console.log(filter);
    const itemList = ["Item Code", "Item Type", "Nodes", "Tags"];
    const dropdown = (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle className="filter-btn" caret>
          {this.state.selectedFilter ? this.state.selectedFilter : "Filter By"}
        </DropdownToggle>
        <DropdownMenu>
          {itemList.map(item => (
            <DropdownItem
              onClick={() => this.setState({ selectedFilter: item })}
            >
              {item}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
    return (
      <div className="rules-filter">
        <InputGroup>
          <InputGroupAddon addonType="prepend">{dropdown}</InputGroupAddon>
          <Input
            onChange={onChg}
            value={filter}
            name="filter"
            type="text"
            placeholder="Search"
          />
          <InputGroupAddon addonType="append">
            <Button className="filter-btn" onClick={() => this.handleFilters()} disabled={(!this.state.selectedFilter && !filter && true)} >
              +
            </Button>
          </InputGroupAddon>
        </InputGroup>
        {this.state.appliedFilters.map(filterTag => (
          <span className="node-name filter-tags">
            <strong>{filterTag.type}: </strong>
            {filterTag.value}
            <label className={`delete-parent-active`}>
              <DeleteButton
                handleDelete={() => this.deleteTag(filterTag.id)}
                index={filterTag.id}
              />
            </label>
          </span>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/Filter.js